import AxiosService from './client/axiosHttpClient';
import DropBoxDataStore from '../../../datastores/DropBoxDataStore';
import { HttpMethod } from './client/http.interface';

export default class DropBoxDataStoreApiRest implements DropBoxDataStore {
  httpClient: AxiosService;

  constructor() {
    this.httpClient = AxiosService.getInstance();
  }

  async generateUrlDocument(path: string, token: string) {
    try {
      const response = await this.httpClient.exchange(
        'https://api.dropboxapi.com/2/files/get_temporary_link',
        {
          method: HttpMethod.Post,
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          data: { path }
        }
      );
      return response;
    } catch (error) {
      throw new Error('error');
    }
  }
}
